module.exports = __webpack_public_path__ + "img/resized-APP-0012-1.4a3fea70.png";